// Copyright 2026. WebPros International GmbH. All rights reserved.


import * as React from 'react';
import { IComputeResourceResponse } from 'common/api/resources/ComputeResource';
import {
    Action,
    List,
    Translate,
} from '@plesk/ui-library';
import {
    RouteComponentProps,
    withRouter,
} from 'react-router';
import { connect } from 'react-redux';
import {
    bindActionCreators,
    Dispatch,
} from 'redux';
import { EmptyView } from 'common/components/EmptyView/EmptyView';
import * as computeResourceActions from 'admin/computeResource/actions';
import { Link } from 'react-router-dom';
import { pathTo } from 'common/helpers/core';
import { getActionColumnProps } from 'common/helpers/list';
import CopyText from 'common/containers/CopyText/CopyText';

const columns = [{
    key: 'colName',
    cellProps: {
        className: 'cell-bold',
    },
    title: <Translate content="computeResource.list.name" />,
}, {
    key: 'colHost',
    title: <Translate content="computeResource.list.host" />,
}, {
    width: '10%',
    key: 'colDrEnabledVms',
    title: <Translate content="computeResource.disasterRecovery.list.drEnabledVms" />,
    cellProps: {
        style: { textAlign: 'right' },
    },
}, {
    width: '10%',
    key: 'colDrDisabledVmsWithBackups',
    title: <Translate content="computeResource.disasterRecovery.list.drDisabledVmsWithBackups" />,
    cellProps: {
        style: { textAlign: 'right' },
    },
}, {
    width: '10%',
    key: 'colLastSeenOnline',
    title: <Translate content="computeResource.disasterRecovery.list.lastSeenOnline" />,
    cellProps: {
        style: { textAlign: 'center' },
    },
}, getActionColumnProps(),
];

export interface IComputeResourceTableProps extends RouteComponentProps {
    items: IComputeResourceResponse[];
}

export type ComputeResourceTableProps =
    IComputeResourceTableProps &
    ReturnType<typeof mapDispatchToProps>;

export const ComputeResourceTableDR: React.FC<ComputeResourceTableProps> = ({
    items,
}) => {
    const data = items
        .map((item) => ({
            colName: (
                <Action
                    component={Link}
                    to={pathTo(`disaster_recovery/compute_resources/${item.id}/recovery`)}
                    className="cell-bold"
                >
                    {item.name}
                </Action>
            ),
            colHost: (<CopyText>{item.host}</CopyText>),
            colDrEnabledVms: item.disaster_recovery_enabled_servers_count,
            colDrDisabledVmsWithBackups: item.backup_enabled_servers_count,
            colLastSeenOnline: item.last_seen_online,
            key: item.id.toString(),
        }));

    return (
        <List
            emptyView={
                <EmptyView
                    title="disasterRecovery.recovery.emptyList.title"
                    description={(
                        <>
                            <p><Translate content="disasterRecovery.recovery.emptyList.description1"/></p>
                            <p><Translate content="disasterRecovery.recovery.emptyList.description2"/></p>
                        </>
                    )}
                />
            }
            columns={columns}
            data={data}
        />
    );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    computeResourceActions: bindActionCreators(computeResourceActions, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(ComputeResourceTableDR));